import { Table } from 'antd';
export default Table;



// WEBPACK FOOTER //
// ./src/components/ui-ant/elements/table.js